import { Switch } from '@headlessui/react';
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

type SwitchProps = {
  checked?: boolean;
  onChange?: (check: boolean) => void;
};

export const SwitchInput = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onChange }, ref) => {
    const [enabled, setEnabled] = useState(checked);

    return (
      <Switch
        ref={ref}
        checked={enabled}
        onChange={(checked) => {
          setEnabled(checked);
          onChange?.(checked);
        }}
        className={twMerge(
          'w-12 rounded-full bg-primary p-1 md:w-16 md:px-1.5',
          checked && 'bg-[#10B981]',
        )}
      >
        <div
          aria-hidden
          className={twMerge(
            'size-4 translate-x-0 rounded-full bg-white transition duration-200 ease-in-out md:size-6',
            enabled && 'translate-x-6 md:translate-x-7',
          )}
        ></div>
      </Switch>
    );
  },
);

SwitchInput.displayName = 'SwitchInput';
